import SSRInterface from '../../interfaces/client/SSR'

import constants from '../../config/constants'

export default (ssr: SSRInterface) =>
  ssr.id.substr(0, 2) !== constants.luggagePrefix
